/**
 * A main-bar menu drawn in place of the actions, for both looks of the bar: "← Back" first, then the
 * chips (icon or emoji over the label), dividers between groups, scrolling sideways when they do not
 * fit — the old kiosk's sub-carousels.
 */
import type { MainBarContent } from './useMainBar';
import { isChip } from '../../packs/menu';
import { useTranslate } from '../../react/hooks';
import { Icon } from '../../ui-kit/Icon';
import css from './Menu.module.css';

export function MenuRow({ bar, look }: { bar: Extract<MainBarContent, { kind: 'menu' }>; look: 'tiles' | 'pills' }) {
  const t = useTranslate();
  return (
    <div className={`${css.row} ${css[look]}`} role="group">
      <button className={`${css.chip} ${css.back}`} onClick={bar.back}>
        <Icon name="back" size={30} />
        <span>{t(bar.nested ? 'menu.return' : 'menu.back')}</span>
      </button>
      {bar.entries.map((e, i) =>
        isChip(e) ? (
          <button key={e.id} className={`${css.chip} ${e.selected ? css.selected : ''} ${e.tone === 'main' ? css.main : ''}`}
            disabled={e.disabled} aria-pressed={e.selected} onClick={() => bar.pick(e)}>
            {e.emoji ? <span className={css.emoji} aria-hidden>{e.emoji}</span> : e.icon ? <Icon name={e.icon} size={30} /> : null}
            <span>{e.label}</span>
          </button>
        ) : (
          <i key={`divider-${i}`} className={css.divider} aria-hidden />
        ),
      )}
    </div>
  );
}
